import { Container, Table } from "react-bootstrap";
import "./Component_4.css";

const Component_4 = () => {
  return (
    <section className="training-schedule">
      <Container>
        <h4 className="component_4-title">Weekly Training Schedule</h4>

        <div className="table-responsive">
          <Table className="component_4-table text-center">
            <thead className="component_4-thead">
              <tr>
                <th className="component_4-day">Monday</th>
                <th className="component_4-day">Tuesday</th>
                <th className="component_4-day">Wednesday</th>
                <th className="component_4-day">Thursday</th>
                <th className="component_4-day">Friday</th>
                <th className="component_4-day">Saturday</th>
                <th className="component_4-day">Sunday</th>
              </tr>
            </thead>

            <tbody className="component_4-tbody">
              <tr>
                <td className="component_4-activity">
                  Running ABC drills & <br /> bodyweight exercises
                </td>
                <td className="component_4-activity">Tempo run</td>
                <td className="component_4-activity">
                  Core exercises <br /> and <br /> strength conditioning
                </td>
                <td className="component_4-activity">
                  Speed workouts —<br />  agility runs, short sprints, hill training
                </td>
                <td className="component_4-activity">Circuit training</td>
                <td className="component_4-activity">
                  Long run <br /> (endurance focus)
                </td>
                <td className="component_4-activity">Rest & recovery</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Container>
    </section>
  );
};

export default Component_4;
